export const spinnerSizes = ['xs', 'sm', 'md', 'lg', 'xl'];

export type SpinnerSize = (typeof spinnerSizes)[number];
